import request from 'api/requestUtils'
import { paths } from '@luxuryescapes/contract-cart'
import { mapMultiCartMemberResponse } from './multiCartMappers'
import type { MachineContext } from 'typings/app/machineContext'

type FetchSuccess = paths['/api/carts/multi-carts/{multiCartId}/users']['get']['responses']['200']['content']['application/json']

export async function getMultiCartMembers(cartId: string): Promise<MachineContext.CartMembers> {
  const cartMembers = await request.get<FetchSuccess>(`/api/carts/multi-carts/${cartId}/users`, { credentials: 'include' }).then(mapMultiCartMemberResponse)
  return { [cartId]: cartMembers }
}
